import { useDeferredValue, useEffect, useMemo, useState } from "react";
import "./styles.scss";
import WalletLayout from "./components/WalletLayout";
import { set, get } from "idb-keyval";
import SearchList from "./SearchList";
import Search from "~components/Search";
import useHeader from "~components/Header/hooks/useHeader";
import { Spinner } from "@chakra-ui/react";

import { useConfigureFooter } from "~hooks/useHelpers";
import useClientes from "~/fetchs/useClientes";
import SearchClient from "~components/Search/SearchClient";
import { useLocation } from "react-router-dom";
import useUsuario from "~fetchs/useUsuario";
import useVendedor from "~fetchs/useVendedor";

const Wallet = ({ hideOthersButtons }) => {
  useConfigureFooter();

  const { carteiraPath } = useHeader();
  const customTabs = [
    { name: "Buscar cliente", link: "/carteira", full: true },
  ];
  const [bloqueadoStatus, setBloqueadoStatus] = useState(false);
  const [tipoPessoaStatus, setTipoPessoaStatus] = useState(false);

  const [loadingSearch, setLoadingSearch] = useState(false);

  const { vendedorSelecionado } = useVendedor();
  const vendedorSelecionadoNormalizado = vendedorSelecionado ?? null;

  const [skip, setSkip] = useState(0);
  const [take] = useState(6);
  const [filtros, setFiltros] = useState({});
  const [buttonClear, setButtonClear] = useState(false);
  const { clientes, total, handleSearch, searchTerm, loadingCached, loadingRequest, todosOsClientes, isQueryPending } = useClientes({
    type: carteiraPath ? 'carteira' : 'recebedor',
    skip: skip,
    take: take,
    setLoadingSearch,
    filters: filtros,
    bloqueadoStatus: bloqueadoStatus,
  });

  const todosOsClientesDeferred = useDeferredValue(todosOsClientes);
  const filtrosKey = useMemo(() => JSON.stringify(filtros || {}), [filtros]);

  useEffect(() => {
    setSkip(0);
  }, [searchTerm, filtrosKey, vendedorSelecionadoNormalizado]);


  const [clickClear, setClickClear] = useState(null);
  const location = useLocation();
   const pathUrl = location.pathname.includes('/carteira');
  return (
    <WalletLayout customTabs={carteiraPath ? customTabs : null}>
      {pathUrl && <SearchClient onChangeFilters={setFiltros} setTipoPessoaStatus={setTipoPessoaStatus} setBloqueadoStatus={setBloqueadoStatus} clickClear={clickClear} setClickClear={setClickClear} todosOsClientes={todosOsClientesDeferred} filtros={filtros} vendedorSelecionado={vendedorSelecionadoNormalizado} buttonClear={buttonClear} setButtonClear={setButtonClear} />}
      <Search
        searchTerm={searchTerm}
        initialValue={searchTerm}
        onSearch={handleSearch}
        placeholder="Buscar Cliente por quaisquer campos exibidos"
        textButton="Novo Cadastro"
        hideButton={carteiraPath}
        setLoading={setLoadingSearch}
        clickClear={clickClear}
        clearButton={true}
        clearButtonPath={pathUrl}
        setButtonClear={setButtonClear}
      />

      {( loadingCached ) ? (
        <div className="container flex items-center justify-center pt-10">
          <Spinner size={"xl"} thickness="4px" />
        </div>
      ) : (
        <SearchList items={clientes} value={searchTerm} skip={skip} take={take} setSkip={setSkip} total={total} hideOthersButtons={hideOthersButtons} loadingRequest={loadingRequest} isQueryPending={isQueryPending || (loadingRequest && clientes.length === 0)} />
      )}

    </WalletLayout>
  );
};

export default Wallet;
